import { FC } from 'react';
import { Trans } from 'react-i18next';
import { TableFooterProps } from './table.type';
import './table.css';
import { getIdAttributes } from '../../utils/helper';

export const idPrefix: string = 'table-footer';

const TableFooter: FC<TableFooterProps> = (props) => {
  const prefix: string = idPrefix;
  return (
    <div className="footer-container" {...getIdAttributes(prefix, 'container')}>
      <div {...getIdAttributes(prefix, 'text')}>
        <Trans
          i18nKey={props.footerText}
          values={{
            displayed: props.displayedCount ?? 0,
            total: props.totalCount ?? 0,
          }}
        />{' '}
        <span className="lowercase" {...getIdAttributes(prefix, 'unit')}>
          <Trans i18nKey={props.unitText} />
        </span>
      </div>
    </div>
  );
};

export default TableFooter;
